import {GetServerSideProps} from "next";
import withLocaleServerSideProps, {defaultNamespaces} from "./withLocaleServerSideProps";
import {I18nNamespace} from "@i18n/constants";

const noOpGetServerSideProps: GetServerSideProps = async () => ({props: {}});

export default function localeServerSideProps(
  namespaces: I18nNamespace[] = defaultNamespaces,
): GetServerSideProps {
  return withLocaleServerSideProps(noOpGetServerSideProps, namespaces);
}
